import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { Box } from "@chakra-ui/react";
import { defaultRoutes, privateRoutes, publicRoutes } from "./routes";
import { useAuth } from "./Providers/AuthProvider";
import Loader from "./components/Loader";
import { Logo } from "./core/Dashboard/components";

function App() {
  const {
    isLoading,
    //  isLoggedIn,
    role,
  } = useAuth();

  console.log(role, "----role");
  return (
    <Box>
      {isLoading ? (
        <Box
          display={"flex"}
          h={"100vh"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box display={{ base: "block", lg: "none" }}>
            <Logo height="1.6rem" />
          </Box>
          <Box display={{ base: "none", lg: "block" }}>
            <Loader />
          </Box>
        </Box>
      ) : (
        <RouterProvider
          router={
            // isLoggedIn
            //   ? createBrowserRouter([...privateRoutes, ...defaultRoutes])
            //   : createBrowserRouter([...publicRoutes, ...defaultRoutes])
            createBrowserRouter([
              ...privateRoutes,
              ...publicRoutes,
              ...defaultRoutes,
            ])
          }
        />
      )}
    </Box>
  );
}

export default App;
